import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const CheckmarkIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 12.14 9.04"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 9.04)}
      {...svgProps}
      fill={color ?? svgProps.fill ?? "currentColor"}
      stroke={svgProps.stroke ?? "none"}
    >
      <path d="M4.34 9.04 0 4.7l1.22-1.22 3.12 3.1L10.92 0l1.22 1.23z" />
    </SVG>
  );
};
